import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'on-edit-invitation-gridcell',
    templateUrl: './edit-invitation-gridcell.component.html',
    styleUrls: ['./edit-invitation-gridcell.component.scss'],
})
export class EditInvitationGridcellComponent
    implements ICellRendererAngularComp
{
    params: any;

    constructor() {}

    editInvitation(event) {
        this.params.context.parent.editInvitation(this.params.data);
    }

    refresh(params: any): boolean {
        return false;
    }
    agInit(params: import('ag-grid-community').ICellRendererParams): void {
        this.params = params;
    }
    afterGuiAttached?(
        params?: import('ag-grid-community').IAfterGuiAttachedParams,
    ): void {}
}
